<template>
  <div id="Wrapper">
    <Header
      :siteInfo="siteInfo"
    />
    <div class="main_container">
      <Sidebar
        :siteInfo="siteInfo"
      />
      <Main
        :siteInfo="siteInfo"
        :cameraInfo="cameraInfo"
        @loadFinish="loadFinish"
      />
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import Main from '../../components/main/Main'

export default {
  name: 'Home',
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    }
  },
  methods: {
    loadFinish() {
      this.$emit('loadFinish');
    },
  },
  components:{
    Header,
    Sidebar,
    Main
  }
}
</script>
<style lang="scss">
</style>